'use strict';

// Import Libraries
import React, { useRef } from 'react';
import classNames from 'classnames';
// Import JSX Modules
import OptionSorter from './option-sorter';
import AppleDeviceNameCapitaliser from '../_utils/apple-device-name-capitaliser';
import DecapitalisedTitle from '../_utils/decapitalised-title';

// -----------------------------------------------------------
//  StandardFilterOptions
// -----------------------------------------------------------
const StandardFilterOptions = ({
  options,
  selected_options: selectedOptions,
  facets,
  onOptionSelected,
  newUi,
}) => {
  return (
    <ul className="list-unstyled checkboxes" role="list">
      {new OptionSorter(options.filter((option) => option.title))
        .sort()
        .map(renderOption, this)}
    </ul>
  );

  function renderOption(option) {
    const selected = selectedOptions.indexOf(option.title) > -1,
      unavailable = (() => {
        if (facets) {
          return !facets.some((facet) => facet.key === option.title);
        }

        return !option.available;
      })();

    const handleOptionSelected = (e) => {
      e.preventDefault();
      onOptionSelected(option.title);
    };

    if (unavailable & newUi) return null;
    return (
      <li
        key={`${option.title}-${selected}`}
        className={classNames('options-list-names mb-1', {
          selected: selected,
          unavailable: unavailable,
        })}>
        <div
          className={classNames(
            'fancy-checkbox-button mr-2 d-flex text-unstyled',
          )}>
          <input
            type="checkbox"
            id={option.title}
            className={classNames('mr-2', {
              selected: selected,
              disabled: unavailable,
            })}
            onChange={handleOptionSelected}
            checked={selected}
            disabled={unavailable}
            aria-label={option.title}></input>
          <label htmlFor={option.title} className="m-0">
            <AppleDeviceNameCapitaliser>
              <DecapitalisedTitle>{option.title}</DecapitalisedTitle>
            </AppleDeviceNameCapitaliser>
          </label>
        </div>
      </li>
    );
  }
};

export default StandardFilterOptions;
